<template>
  <div class="edit-product">
    <div class="breadcrumb" style="background: #fff">开码详情</div>
    <div class="third-title"><span>开码信息</span></div>
    <div class="order-detail-basic" style="padding-top: 0">
      <el-form ref="rules" class="demo-ruleForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="产品名称"> {{ showDate.spuName }} </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="规格"> {{ showDate.skuName }} </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="P数"> {{ showDate.sku.page }} </el-form-item>
          </el-col>
          <el-col :span="12" v-if="showDate.usedQuantity">
            <el-form-item label="产品数量"> {{ showDate.usedQuantity }} </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开码总数"> {{ showDate.quantity }} </el-form-item>
          </el-col>
          <el-col :span="12" v-if="codeType !== 'free'">
            <el-form-item label="开码总价"> {{ showDate.amount }} </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="已使用"> {{ showDate.codeCount.countUsed }} </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="已删除"> {{ showDate.codeCount.countDeleted }} </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="有效期至"> {{ showDate.dateExpired }} </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="平台号"> {{ showDate.store.code }} </el-form-item>
          </el-col>
          <el-col :span="12" v-if="codeType !== 'free'">
            <el-form-item label="已推送"> {{ showDate.codeCount.countPushed }} </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="平台名称"> {{ showDate.store.name }} </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
        </el-row>
        <el-row>
        </el-row>
        <el-row>
        </el-row>
        <el-row>
        </el-row> -->
      </el-form>
    </div>
    <div class="third-title"><span>码池</span><span v-if="showDate.paymentType === 'VP_SETTLE' || showDate.paymentType === 'VP_BONUS'"
        style="margin-left:10px;font-size:12px;color:red;">注：该批码生成的订单，无法开发票！</span></div>
    <div style="position: relative;">
      <div style="position: absolute;right: 0;top: 0;z-index: 99;">
        <el-button type="primary" v-show="seleAllShow" round @click.native="selectAll()">全选</el-button>
        <el-button type="primary" v-if="delShow && $hasPermission('psm:admin:promo:delete') && codeType !== 'free'" round @click="selectDelete()">删除</el-button>
        <el-button type="primary" v-if="!delShow && $hasPermission('psm:admin:promo:delete') && codeType === 'free'" round @click="selectDelete()">删除</el-button>
        <el-button type="primary" v-show="exportDateShow" round @click="exportDate()">导出</el-button>
      </div>
      <template>
        <el-tabs v-model="activeName" @tab-click="handleClick" style="margin-left: 50px;margin-top: 30px">
          <el-tab-pane :label="'已开码(' + openNumber + ')'" name="first">
            <template>
              <div style='width: 100%;height: 200px; overflow: auto;'>
                <el-checkbox-group v-model="pushForm.promoCodeIds" size="mini">
                  <el-checkbox-button style='margin-left: 10px;margin-top: 10px;border-left: 1px solid #DCDFE6;width: 100px' v-for="date in promoCodes" :label="date.promoCodeId"
                    :key="date.promoCodeId"> {{ date.code }}</el-checkbox-button>
                </el-checkbox-group>
              </div>
            </template>
          </el-tab-pane>
          <el-tab-pane :label="pushShareNumber ? '已分享/未领取（' + pushShareNumber + '）' : '已分享/未领取（0）'" name="second1">
            <div class="myorder-table myorder-table-noborder" style="border: 1px solid #F2F2F2;">
              <el-table border class="table-cell" :data="promoListShare">
                <el-table-column prop="code" :label="codeType !== 'free' ? '免单码' : '余额支付码'" min-width="100px"></el-table-column>
                <el-table-column prop="phone" label="推送手机号" min-width="200px"></el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="pushNumber ? '已推送/已领取（' + pushNumber + '）' : '已推送/已领取（0）'" name="second">
            <div class="myorder-table myorder-table-noborder" style="border: 1px solid #F2F2F2;">
              <el-table border class="table-cell" :data="promoList">
                <el-table-column prop="code" :label="codeType !== 'free' ? '免单码' : '余额支付码'" min-width="100px"></el-table-column>
                <el-table-column prop="phone" label="推送手机号" min-width="200px"></el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="'已删除(' + deletedNumber + ')'" name="third">
            <template>
              <div style='width: 800px'>
                <el-checkbox-group v-model="pushForm.promoCodeIds" size="mini">
                  <el-checkbox-button style='margin-left: 10px;margin-top: 10px;border-left: 1px solid #DCDFE6;' v-for="date in removeList" :label="date.promoCodeId" :key="date.promoCodeId"> {{
                    date.code }}</el-checkbox-button>
                </el-checkbox-group>
              </div>
            </template>
          </el-tab-pane>
          <el-tab-pane :label="'已使用(' + usedNumber + ')'" name="fourth">
            <template>
              <div style='width: 800px'>
                <el-checkbox-group v-model="pushForm.promoCodeIds" size="mini">
                  <el-checkbox-button style='margin-left: 10px;margin-top: 10px;border-left: 1px solid #DCDFE6;' v-for="date in usedList" :label="date.promoCodeId" :key="date.promoCodeId">{{ date.code
                  }} </el-checkbox-button>
                </el-checkbox-group>
              </div>
            </template>
          </el-tab-pane>
        </el-tabs>
      </template>
    </div>
    <div style="height: 80px"></div>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="promptIsShow" width="30%">
      <span>删除后不可恢复，是否删除选中的码，删除后金额自动返还至余额</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="promptIsShow = false" round>取 消</el-button>
        <el-button style='float: right' type="primary" round @click="delBatch()">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getDetailByPromoId, delBatchPromo } from '@/api/epay'
export default {
  name: 'promo-detail',
  data () {
    return {
      seleAllShow: true,
      delShow: true,
      exportDateShow: true,
      promptIsShow: false,
      checkAll: false,
      isIndeterminate: true,
      openNumber: '',
      pushNumber: '',
      pushShareNumber: '',
      deletedNumber: '',
      usedNumber: '',
      outputs: [],
      priviewPush: false,
      pushDialog: false,
      pushBatchDialog: false,
      pushBatchDate: [],
      pushCodeNoEnoughDialog: false,
      phone: '',
      activeName: 'first',
      showDate: {
        store: {},
        sku: {},
        codeCount: {}
      },
      promoCodes: [],
      promoList: [],
      promoListShare: [],
      removeList: [],
      usedList: [],
      pushForm: {
        promoCodeIds: []
      },
      templatePath: '',
      templateFile: '',
      orderId: ''
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  created () {
    this.codeType = this.$route.query.code
    console.log('this.codeType', this.codeType)
    let id = this.$route.query.id
    this.orderId = id
    this.getDetailByPromoId(id)
  },
  watch: {
    activeName () {
      if (this.activeName === 'first') {
        this.seleAllShow = true
        this.delShow = true
        this.exportDateShow = true
      } else {
        this.seleAllShow = false
        this.delShow = false
        this.exportDateShow = true
      }
    }
  },
  methods: {
    selectDelete () {
      if (this.pushForm.promoCodeIds.length) {
        this.promptIsShow = true
      } else {
        this.$message.warning('请选择要删除的码！')
      }
    },
    selectAll () {
      var tempDate = []
      if (this.activeName === 'first') {
        if (this.pushForm.promoCodeIds?.length === this.promoCodes?.length) {
          this.pushForm.promoCodeIds = []
        } else {
          tempDate = this.promoCodes
        }
      }
      if (this.activeName === 'third') {
        tempDate = this.removeList
      }
      if (this.activeName === 'fourth') {
        tempDate = this.usedList
      }
      // if (this.activeName === 'second') {
      //   tempDate = this.promoList
      // }
      console.log(tempDate)
      for (let i = 0; i < tempDate.length; i++) {
        this.pushForm.promoCodeIds.push(tempDate[i].promoCodeId)
      }
    },
    handleClick (tab, event) {
      console.log(tab, event)
    },
    getDetailByPromoId (id) {
      getDetailByPromoId(id).then(res => {
        if (res.data.success) {
          let dat = res.data.data
          if (dat.promoType === 'SPU') {
            this.showDate = {
              ...dat,
              spuName: dat.name,
              skuName: ''
            }
          } else {
            this.showDate = {
              ...dat,
              skuName: dat.sku.skuName,
              spuName: dat.sku.spuName
            }
          }
          this.openNumber = this.showDate.codeCount.countUnUsed
          this.pushNumber = this.showDate.codeCount.countPushed
          this.pushShareNumber = this.showDate.codeCount.sharedNoReceive
          this.usedNumber = this.showDate.codeCount.countUsed
          this.deletedNumber = this.showDate.codeCount.countDeleted
          const temp = res.data.data.promoCodes.map(a => {
            if (a.phone) {
              a.phone = this.$msg.filterBridal(a.phone)
            }
            return a
          })
          for (let i = 0; i < temp.length; i++) {
            if (temp[i].promoCodeStatus === 'PRODUCED') { // 已开码
              this.promoCodes.push(temp[i])
            } else if (temp[i].promoCodeStatus === 'PUSHED') { // 已推送
              this.promoList.push(temp[i])
            } else if (temp[i].promoCodeStatus === 'SHAREDNORECEIVE') { // 已分享
              this.promoListShare.push(temp[i])
            } else if (temp[i].promoCodeStatus === 'DELETED') { // 已删除
              this.removeList.push(temp[i])
            } else if (temp[i].promoCodeStatus === 'USED') { // 已使用
              this.usedList.push(temp[i])
            }
          }
          console.log(this.removeList)
        }
      })
    },
    exportDate () {
      var XLSX = require('xlsx')
      var exportDate = []
      var tempDate = []
      if (this.activeName === 'first' || this.activeName === 'third') {
        if (this.activeName === 'first') {
          tempDate = this.promoCodes
        }
        if (this.activeName === 'third') {
          tempDate = this.removeList
        }

        for (let i = 0; i < tempDate.length; i++) {
          // const temp = {
          //   免单码: this.promoCodes[i].code
          // }
          let temp = null
          if (this.codeType !== 'free') {
            temp = {
              免单码: tempDate[i].code
            }
          } else {
            temp = {
              余额支付码: tempDate[i].code
            }
          }
          exportDate.push(temp)
        }
      } else {
        if (this.activeName === 'fourth') {
          tempDate = this.usedList
        } else {
          tempDate = this.promoList
        }
        console.log('tempDate', tempDate)
        for (let i = 0; i < tempDate.length; i++) {
          let temp = null
          if (this.codeType !== 'free') {
            temp = {
              手机号: tempDate[i].phone || tempDate[i].usedPhone,
              免单码: tempDate[i].code
            }
          } else {
            temp = {
              手机号: tempDate[i].phone || tempDate[i].usedPhone,
              余额支付码: tempDate[i].code
            }
          }
          exportDate.push(temp)
        }
      }
      // 新建空workbook，然后加入worksheet
      const ws = XLSX.utils.json_to_sheet(exportDate)
      // 设置每列的列宽，10代表10个字符，注意中文占2个字符
      ws['!cols'] = [
        { wch: 10 },
        { wch: 30 },
        { wch: 25 }
      ]
      // 新建book
      const wb = XLSX.utils.book_new()
      // 生成xlsx文件(book,sheet数据,sheet命名)
      XLSX.utils.book_append_sheet(wb, ws, '数据详情')
      // 写文件(book,xlsx文件名称)
      let name = this.codeType == 'free' ? '余额支付码' : this.codeType == 'promoApp' ? 'APP免单码' : '免单码'
      XLSX.writeFile(wb, name + '.xlsx')
    },
    delBatch () {
      // var tempDate = this.pushForm.promoCodeIds
      // if (this.activeName === 'first') {
      //   tempDate = this.promoCodes
      // }
      // if (this.activeName === 'third') {
      //   tempDate = this.removeList
      // }
      // if (this.activeName === 'fourth') {
      //   tempDate = this.usedList
      // }
      // if (this.activeName === 'second') {
      //   tempDate = this.promoList
      // }
      // if (tempDate.length < 1) {
      //   this.$message.success('请选择要删除的码！')
      //   return;
      // }
      // var promoCodeIds = [];
      // for (let i = 0; i < tempDate.length; i++) {
      //   promoCodeIds.push(tempDate[i].promoCodeId)
      // }
      const loading = this.$loading({
        lock: true,
        text: '正在删除',
        spTEXT: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let promoCodeVo = {
        orderId: this.orderId,
        promoCodeIds: this.pushForm.promoCodeIds
      }
      delBatchPromo(promoCodeVo).then(res => {
        if (res.data.success) {
          this.cleanArr()
          this.promptIsShow = false
          this.$message.success('已删除！')
          loading.close()
          this.getDetailByPromoId(this.orderId)
        }
      })
    },
    cleanArr () {
      this.pushForm.promoCodeIds = []
      this.promoCodes = []
      this.promoList = []
      this.removeList = []
      this.usedList = []
    }
  }
}
</script>
<style scoped lang="less">
@deep: ~">>>";

/deep/.el-checkbox-button__inner {
  display: inline-block;
  width: 90px;

}
</style>
